import { useTranslator } from '@bluebeam/react-i18n';
import QuestionSpeechBubble from 'components/Icons/QuestionSpeechBubble';
import React from 'react';
import { Project } from 'records/Project';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import CountsCard from './CountsCard';
import RFIItems from './RFIItems';

interface Props extends WithAppStoreProps {
  onViewAllClicked: (projectId: string) => void;
  onActiveRFIsClicked?: (projectId: string) => void;
  onOverdueRFIsClicked?: (projectId: string) => void;
  onCreateRFIClicked: (projectId: string) => void;
}

const RFIs: React.FC<Props> = (props: Props) => {
  const {
    onViewAllClicked,
    onActiveRFIsClicked,
    onOverdueRFIsClicked,
    onCreateRFIClicked,
    appState,
  } = props;
  const { queriedRFIs, projects, selectedProject } = appState;
  const { translate } = useTranslator(['roverDashboard']);
  const project = projects.get(selectedProject, new Project());
  const canRFI = project.permissions.createRfi;

  const getIcon = (): React.ReactNode => {
    return <QuestionSpeechBubble width="16px" height="15px" />;
  };

  const getItems = (): React.ReactNode => {
    return (
      <RFIItems
        onActiveRFIsClicked={onActiveRFIsClicked}
        onOverdueRFIsClicked={onOverdueRFIsClicked}
      />
    );
  };

  return (
    <div className="row w100 h100">
      <CountsCard
        id="dashboard-rfi-card"
        onViewAllClicked={onViewAllClicked}
        onActiveClicked={onActiveRFIsClicked}
        onOverdueClicked={onOverdueRFIsClicked}
        onCreateClicked={onCreateRFIClicked}
        title={translate('roverDashboard:RFIs')}
        count={queriedRFIs.size}
        createLabel={translate('roverDashboard:createRFI')}
        emptyMsg={translate('roverDashboard:emptyRFIMsg')}
        emptyLabel={translate('roverDashboard:noRFIs')}
        icon={getIcon()}
        items={getItems()}
        hasPermission={canRFI}
      />
    </div>
  );
};

export default withAppStore<Props>(RFIs);
